// extracted by extract-css-chunks-webpack-plugin
module.exports = {"image":"ach-payment-method__image___3UUVD","image-container":"ach-payment-method__image-container___1COql","imageContainer":"ach-payment-method__image-container___1COql","image-description":"ach-payment-method__image-description___2y2JX","imageDescription":"ach-payment-method__image-description___2y2JX","image-active":"ach-payment-method__image-active___1y3gY","imageActive":"ach-payment-method__image-active___1y3gY"};
    if(module.hot) {
      // 1747974131038
      var cssReload = require("../../../../node_modules/extract-css-chunks-webpack-plugin/dist/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}","cssModules":true});
      module.hot.dispose(cssReload);
      ;
    }
  